
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M2.25 2.25a1.5 1.5 0 00-1.5 1.5v18a1.5 1.5 0 001.5 1.5h19.5a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5h-6.879a1.5 1.5 0 01-1.06-.439l-3.622-3.622a1.5 1.5 0 01-.439-1.06V9.75a1.5 1.5 0 00-1.5-1.5h-1.5a1.5 1.5 0 01-1.5-1.5v-3a1.5 1.5 0 00-1.5-1.5zM5.25 3.75h18M12.75 8.25h10.5M13.5 12.75h9.75M9.75.75v4.5M14.25.75v12M18.75.75v16.5"}})])
          )
        }
      }
    